import httpUtils from '../../utils/HttpUtils'

class SensitiveWordsService {

  //获取敏感词列表信息
  async list() {
    let result = null;
    try {
      result = await httpUtils.post('/qa/sensitive/words/list')
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

}
export default new SensitiveWordsService()
